import * as React from 'react';
import { DialogTitle } from '@material-ui/core';
import { DialogContent } from '@material-ui/core';
import { DialogActions } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { translation } from '../../i18n';
import { Dialog } from '@material-ui/core';
import { emptyQuestionnaireRequest, QuestionnaireDto, QuestionnaireRequest } from './questionnaireTypes';
import { Typography } from '@material-ui/core';
import moment from 'moment';
import { IObservableObject, observable } from 'mobx';
import { observer } from 'mobx-react';

interface Props {
  onClose: () => void;
  questionnaire: QuestionnaireDto & IObservableObject;
  open: boolean;
}

@observer
export default class QuestionnaireDialog extends React.Component<Props> {

  @observable private questionnaire: QuestionnaireRequest & IObservableObject = observable(emptyQuestionnaireRequest());

  constructor(props: Props) {
    super(props);
    this.init = this.init.bind(this);
  }

  public render() {
    return (
      <Dialog
        id="newQuestionnaireDialog"
        open={this.props.open}
        onClose={this.props.onClose}
        fullWidth={true}
        maxWidth="md"
        onRendered={this.init}
      >
        <DialogTitle id="form-dialog-title">{this.questionnaire.title}</DialogTitle>

        <DialogContent>
          <Typography variant="body1">
            {this.questionnaire.description}
          </Typography>
          {
            this.questionnaire.anonymous &&
            <Typography variant="body1">
              {translation.t('questionnaireComponent.anonymous')}
            </Typography>
          }
          <Typography variant="body1">
            {translation.t('questionnaire.startDate')}: {moment(this.questionnaire.startDate).format('DD.MM.YYYY')}
          </Typography>
          <Typography variant="body1">
            {translation.t('questionnaire.endDate')}: {moment(this.questionnaire.endDate).format('DD.MM.YYYY')}
          </Typography>
          <Typography variant="body1">
            {translation.t('questionnaire.appraisee')}: {this.questionnaire.appraisee.firstName + ' ' + this.questionnaire.appraisee.lastName}
          </Typography>
          <Typography variant="body1">
            {translation.t('questionnaire.appraisers')}:
          </Typography>
          <ul>
            {
              this.questionnaire.appraisers.map(appraiser => (
                <li key={appraiser.id}>
                  <Typography variant="body1">
                    {appraiser.firstName + ' ' + appraiser.lastName}
                  </Typography>
                </li>
              ))
            }
          </ul>
          <Typography variant="body1">
            {translation.t('questionnaire.questionCatalogue')}: {this.questionnaire.catalogue.title}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose} color="primary">
            {translation.t('actions.ok')}
          </Button>
        </DialogActions>

      </Dialog>)
  }

  private init() {
    this.questionnaire = this.props.questionnaire;
  }
}
